import AOS from 'aos';

/**
 * Set available positions based on the selected city
 * @param {HTMLElement} selectedCityToggleEl
 * @returns
 */
export function setAvailablePositions(selectedCityToggleEl) {
  if (!selectedCityToggleEl) {
    return;
  }

  const targetCareersListingComponent = selectedCityToggleEl.closest('[data-careers-listing]');

  if (!targetCareersListingComponent) {
    return;
  }

  // remove/add active class
  const cityToggleWrapperEls = targetCareersListingComponent.querySelectorAll('[data-city-toggle-wrapper]');

  if (cityToggleWrapperEls) {
    cityToggleWrapperEls.forEach(el => el.classList.remove('careers-listing__city-nav-item--active'));
  }

  selectedCityToggleEl.closest('[data-city-toggle-wrapper]').classList.toggle('careers-listing__city-nav-item--active');

  // show things
  targetCareersListingComponent
    .querySelectorAll('[data-job-item], [data-department-card]')
    .forEach(el => el.classList.toggle('hidden', false));

  // unless this is the all filter, filter jobs by city name
  if (selectedCityToggleEl.innerText !== 'All') {
    targetCareersListingComponent
      .querySelectorAll('[data-job-item]:not([data-job-city*=\'' + selectedCityToggleEl.innerText.trim() + '\' i])')
      .forEach(el => el.classList.toggle('hidden', true));
  }

  // hide cards that don't have any jobs in them
  targetCareersListingComponent
    .querySelectorAll('[data-department-card]')
    .forEach(el => {
      let jobItemEls = el.querySelectorAll('[data-job-item]');

      el.classList.toggle(
        'hidden',
        Array.from(jobItemEls).filter(el => el.classList.contains('hidden')).length === jobItemEls.length
      );
    });


  const selectedCity = selectedCityToggleEl.innerText;

  // internships section not enabled for all cities

  const internshipsSection = document.querySelector('[data-internships-card]');

  if (internshipsSection) {
    internshipsSection.classList.toggle('hidden', ['Gurgaon', 'London', 'Miami'].includes(selectedCity));
  }

  // show "no jobs available" card
  targetCareersListingComponent
    .querySelectorAll('[data-no-job-card]')
    .forEach(el => el.classList.toggle(
      'hidden',
      Array.from(targetCareersListingComponent.querySelectorAll('[data-department-card]'))
        .filter(el => !el.classList.contains('hidden'))
        .length)
    );

  AOS.refresh();
}
